import React from 'react';
import IntroSection from './sections/intro-section';
import HighlightSection from './sections/highlight-section';
import ServiceSection from './sections/services-section';
import TestimonialSection from './sections/testimonial-section';
import MobileAppSection from './sections/mobile-app-section';
import BannerSection from './sections/banner-section';
import Header2 from '@/feature-module/common/header/header-2';

const HomeThemeTwo = (props: any) => {
  const { themeData, collections } = props;

  return (
    <>
      {/* <Header2 themeData={themeData} /> */}
      <div className="home-two-main-wrapper">
        <BannerSection themeData={themeData} />
        <IntroSection themeData={themeData} />
        <HighlightSection themeData={themeData} />
        <ServiceSection themeData={themeData} />
        <TestimonialSection themeData={themeData} />
        <MobileAppSection themeData={themeData} />
      </div>
    </>
  );
};

export default HomeThemeTwo;
